import { Box, Divider, Typography } from "@mui/material";
import { useBarragemContext } from "../../context";
import { ContatosInternosPage } from "../listaContatos";
import { ErrorOnDialog, LoadingModal } from "../modals";
import { useEffect, useState } from "react";
import { CompanyData } from "../../pages";
import { RequestError, useApi } from "../../services";
import { Municipio } from "../estadoMunicipio";
import { formatBrazilianPhone } from "../../core";

export const IdentificacaoEmpreendimentoEmpreendedor = () => {
  const api = useApi();
  const { barragem } = useBarragemContext();

  const [empreendimento, setEmpreendimento] = useState<CompanyData>();
  const [municipio, setMunicipio] = useState<Municipio>();
  const [error, setError] = useState<RequestError>();

  useEffect(() => {
    if (!barragem || "error" in barragem) return;

    api.company.company(barragem.idEmpreendimento).then((value) => {
      if ("error" in value) {
        setError(value);
        return;
      }
      setEmpreendimento(value);

      api.estadosMunicipios.getMunicipio(value.municipio).then((value) => {
        if ("error" in value) {
          setError(value);
          return;
        }
        setMunicipio(value);
      });

    });

  }, [barragem]);

  if (!barragem || "error" in barragem || !empreendimento || !municipio) {
    return <LoadingModal open={true} />;
  }

  return <>
    <ErrorOnDialog
      open={Boolean(error)}
      error={error?.error ?? ""}
      message={error?.message ?? ""}
      onClose={() => setError(undefined)}
    />

    <Box sx={{
      flex: 1,
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}>
      <Typography fontSize={22} fontWeight={"bold"}>IDENTIFICAÇÃO DO EMPREENDEDOR</Typography>
      <Item title="Nome da Estrutura" value={barragem.nome} />
      <Item title="Empreendedor" value={empreendimento.nome} />
      <Item title="CNPJ" value={empreendimento.cnpj} />
      <Item title="Endereço - Sede Administrativa" value={empreendimento.sede} />
      <Item title="Telefone - Sede Administrativa" value={formatBrazilianPhone(empreendimento.phone)} />
      <Item title="Município" value={municipio.nome} />
      <Item title="Estado" value={municipio.microrregiao.mesorregiao.UF.nome} />

      <div style={{ height: "15px" }} />

      <Typography fontSize={22} fontWeight={"bold"}>CONTATOS DO EMPREENDEDOR</Typography>
      <Box sx={{ flex: 1, width: "100%", overflow: "auto" }}>
        <ContatosInternosPage
          omitTitle
          idBarragem={barragem && !("error" in barragem) ? barragem.id : -1}
        />
      </Box>


    </Box>
  </>;
};

const Item: React.FC<{ title: string; value: string; }> = ({ title, value }) => {
  return <Box sx={{
    gap: "1em",
    p: "0.02em",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    border: "0.5px solid black",
  }}>
    <div style={{ flex: 1, display: "flex", justifyContent: "end" }}>
      <Typography fontSize={16}>{title}</Typography>
    </div>

    <Divider orientation='vertical' />

    <div style={{ flex: 1, display: "flex", justifyContent: "start" }}>
      <Typography fontSize={16}>{value}</Typography>
    </div>
  </Box>;
};